/**
 * API Error Utilities
 *
 * Shared utilities for extracting error messages from API responses.
 */

/**
 * Type representing an API error with optional response data
 */
export interface ApiError {
  response?: { data?: { message?: string; error?: string } };
  message?: string;
}

/**
 * Extract a user-friendly error message from an API error.
 *
 * Tries to extract the message in this order:
 * 1. response.data.message (backend-provided message)
 * 2. response.data.error (alternative backend error field)
 * 3. error.message (axios/fetch error message)
 * 4. fallback message
 *
 * @param error - The caught error object
 * @param fallback - Default message if no error message is found
 * @returns The extracted error message or fallback
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const apiError = error as ApiError;
  return (
    apiError.response?.data?.message ??
    apiError.response?.data?.error ??
    apiError.message ??
    fallback
  );
}
